import { render } from "./RestorePasswordSend.vue?vue&type=template&id=60118a24"
import script from "./RestorePasswordSend.vue?vue&type=script&lang=js"
export * from "./RestorePasswordSend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__